import { BaseDetail } from 'App/Component/Bases'
import fields from 'App/Screens/Job/JobGrades/fields'

class PageAdd extends BaseDetail {
  constructor(props) {
    super(props)

    this.title = 'Job Grade'
    this.urlData = 'module-job-jobGrade'
    this.fields = fields
    this.state = {
      isCheckingPermission: false,
      isAccessAllowed: true
    }
  }
}

export default PageAdd